/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */

import INTENT_TYPES from "../../../constants/intentTypes";

export function normalizeIntakeResponse(apiResponse) {
  const output = apiResponse?.output_text;

  // Safety fallback
  if (!output) {
    return {
      type: "text",
      text: apiResponse.response || "I’ve processed your request.",
      outputText: apiResponse,
    };
  }

  // API-level failure
  if (output.ok === false) {
    return {
      type: "error",
      summary: output.error?.message || `Something went wrong while contacting the Intake Agent. Try again shortly.`,
      outputText: apiResponse,
    };
  }

  const type = output.intent
    ? output.intent.includes(INTENT_TYPES.CLUSTER)
      ? "cluster"
      : output.intent.includes(INTENT_TYPES.DUPLICATE)
        ? "duplicate_result"
        : "run_summary"
    : "run_summary";

  return {
    type,
    intent: output.intent,
    summary: apiResponse?.response || "",
    matches: output.matches || [],
    clusters: output.clusters || [],
    counts: output.counts || null,
    outputText: apiResponse,
    agent: apiResponse?.agent,
    inputRecord: output.input_record || null,
  };
}
